import { login, logout, profileGetInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    id:'',
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
	  userType: '',
    permissions: [],
    isClientCompany: false, // 判断用户角色
    userPhone:'',
    userEmail:'',
    companyId:'',
    companyName:'',
    phonenumber:'',
    ModalShow:false,//登录弹窗显示状态
    typeAndBrand:'',//供货类型及品牌
    guidanceList:[],//指引步骤列表
    startDialog:false,
    tin:'',
  },

  mutations: {
    SET_STARTDIALOG:(state,list)=>{
      state.startDialog = list
    },
    SET_GUIDANCELIST:(state,list)=>{
      state.guidanceList = list
    },
    SET_TIN: (state, tin) => {
      state.tin = tin
    },
    SET_TYPEANDBRAMD: (state, typeAndBrand) => {
      state.typeAndBrand = typeAndBrand
    },
    SET_PHONE_NUMBER: (state, phonenumber) => {
      state.phonenumber = phonenumber
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERPHONE: (state, userPhone) => {
      state.userPhone = userPhone
    },
    SET_USEREMAIL: (state, userEmail) => {
      state.userEmail = userEmail
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_IS_CLIENT_COMPANY: (state, isClientCompany) => {
      state.isClientCompany = isClientCompany
    },
    SET_COMPANY_ID: (state, companyId) => {
      state.companyId = companyId
    },
    SET_COMPANY_NAME: (state, companyName) => {
      state.companyName = companyName
    },
    showUnauthorizedModal: (state, val) => {
      state.ModalShow = val
    },
  },

  actions: {
    startDialogMd({ commit }, bol){
      commit('SET_STARTDIALOG',bol)
    },
     HandleGuidanceList({ commit }, obj){
      obj.list.map(item=>{
        item.current=false
      })
      obj.list[obj.current].current=true
      commit('SET_GUIDANCELIST', obj.list)
    },
    setToken({ commit },token){
        commit('SET_TOKEN', token)
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        // loginZtb(username, password, code, uuid).then(res => {
        //   setTokenZtb(res.token)
        //   commit('SET_TOKEN_ZTB', res.token)
        // }).catch(error => {
        // });
        login(userInfo).then(res => {
          if(res.code==200){
            setToken(res.token)
            commit('SET_TOKEN', res.token)
            resolve(res)
          }else{
            resolve(res)
          }

        }).catch(error => {
          reject(error)
        });
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        profileGetInfo().then(res => {
          commit('SET_IS_CLIENT_COMPANY', res.isClientCompany)
          const user = res.data
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_ID', user.id)
          commit('SET_NAME', user.nickName)
          commit('SET_COMPANY_NAME',user.supplierName)
          commit('SET_COMPANY_ID',user.supplierId)
          commit('SET_USEREMAIL',user.email)
          commit('SET_PHONE_NUMBER',user.phonenumber)
          commit('SET_TYPEANDBRAMD',user.typeAndBrand)
          commit('SET_TIN',user.tin)

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_NAME', '')
          commit('SET_COMPANY_NAME','')
          commit('SET_COMPANY_ID','')
          commit('SET_PHONE_NUMBER','')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
